import { render, staticRenderFns } from "./TokenManagement.vue?vue&type=template&id=23335f06"
import script from "./TokenManagement.vue?vue&type=script&lang=js"
export * from "./TokenManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports